// Smooth open/close per <details> dell'accordion del product-drawer.
// Sostituisce il toggle native (istantaneo) con un'animazione height.
// Idempotente: se viene re-inizializzato (es. dopo Section Rendering API
// che ridisegna il drawer), salta i <details> già inizializzati.

(function () {
  'use strict';

  var DURATION = 420; // ms
  var EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)'; // smooth deceleration

  function SmoothDetails(details) {
    if (details.__czSmoothInit) return;
    details.__czSmoothInit = true;

    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    function contentHeight() {
      // Sum altezze di tutti i child di details escluso il summary.
      var h = 0;
      Array.prototype.forEach.call(details.children, function (el) {
        if (el === summary) return;
        h += el.scrollHeight;
      });
      return h;
    }

    function open() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(expand);
    }

    function expand() {
      isExpanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = (summary.offsetHeight + contentHeight()) + 'px';
      if (animation) animation.cancel();
      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING }
      );
      animation.onfinish = function () { finish(true); };
      animation.oncancel = function () { isExpanding = false; };
    }

    function shrink() {
      isClosing = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING }
      );
      animation.onfinish = function () { finish(false); };
      animation.oncancel = function () { isClosing = false; };
    }

    function finish(openState) {
      details.open = openState;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (isClosing || !details.open) open();
      else if (isExpanding || details.open) shrink();
    });
  }

  function init() {
    var nodes = document.querySelectorAll('.product-drawer__accordion-wrap details, .cz-smooth-accordion details');
    Array.prototype.forEach.call(nodes, SmoothDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init dopo Section Rendering API (variant switch, product drawer refresh).
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
})();
